import React, { useState, useEffect } from 'react';
import StyledRichText from 'components/RichText/StyledRichText';
import Cookies from 'js-cookie';
import TableOfContents from '../TableOfContents';

import { ChapterProgress, ContentKicker, ContentLayout, ContentTitle } from '../styles';

const PlaybookDetailsContent = ({ section, sectionInfo, chapters, splashPageSlug }) => {
  const { current_section, current_chapter, total_chapters, total_sections, next } = sectionInfo;
  const [percentComplete, setPercent] = useState(0);

  useEffect(() => {
    if (Cookies.get('playbook_progress')) {
      const playbook_progress = JSON.parse(Cookies.get('playbook_progress'));
      const percent =
        100 * (playbook_progress[current_chapter].reduce((x, y) => x + y) / total_sections);
      setPercent(percent);
    }
  }, []);

  const nextLink = {
    link: `${splashPageSlug}`,
    buttonLabel: next || 'Return to Playbook Home Page',
  };

  if (current_section + 1 < total_sections) {
    nextLink.link += `/${chapters[current_chapter].sections[current_section + 1].slug}`;
    nextLink.buttonLabel = `Go to Section ${current_section + 2}`;
  } else if (current_chapter + 1 < total_chapters) {
    nextLink.link += `/${chapters[current_chapter + 1].sections[0].slug}`;
    nextLink.buttonLabel = `Go to Chapter ${current_chapter + 2}`;
  }

  let toc;
  let body;

  if (
    section?.content?.json?.content[0]?.content[0]?.value
      ?.toLowerCase()
      ?.includes('table of content') &&
    section?.content?.json?.content[1]?.nodeType == 'ordered-list'
  ) {
    toc = section?.content?.json?.content?.slice(0, 2);
    body = section?.content?.json?.content?.slice(2, section?.content?.json?.content?.length);
  }

  return (
    <>
      <ChapterProgress percent={percentComplete} showInfo={false} strokeColor="#1890ff" />
      <ContentLayout backgroundColor="White">
        {toc && <TableOfContents content={{ content: toc, data: {}, nodeType: 'document' }} />}
        <ContentKicker>
          SECTION {current_section + 1} OF {total_sections}
        </ContentKicker>
        <ContentTitle>{section.title}</ContentTitle>
        <StyledRichText
          content={
            !toc ? section?.content?.json : { content: body, data: {}, nodeType: 'document' }
          }
        />
      </ContentLayout>
    </>
  );
};

export default PlaybookDetailsContent;
